import { Button } from "antd";
import { RegisteredTrusteeSteps } from "..";
import styles from "../../../NGO.module.scss";

interface IAddBusinessOwnerAction {
  handleNextStep: (_step: RegisteredTrusteeSteps) => void;
}

const AddBusinessOwnerAction = ({
  handleNextStep,
}: IAddBusinessOwnerAction) => {
  return (
    <div className={styles.RegisteredTrusteeAction}>
      <div className={styles.ActionContainer}>
        <Button
          type="primary"
          size="large"
          className={styles.ActionButton}
          onClick={() =>
            handleNextStep(RegisteredTrusteeSteps.ADD_TRUSTEE_STEPS)
          }
        >
          Add Registered Trustee
        </Button>
      </div>
    </div>
  );
};

export default AddBusinessOwnerAction;
